import http from 'hub-http/clients/apiClient';
export const fetchInstalledApps = () => {
  return http.get(`appinstalls/v3/app-install/installed-apps-for-ui-new`);
};